
import {
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  ReferenceInput,
  SelectInput,
  FileInput,
  FileField,
  useDataProvider,
  required,
  useNotify,
  useRedirect,
  usePermissions,
  Resource,
} from "react-admin";

const UserGuideCreate = () => {
  console.log(Resource)
  const { permissions = [] } = usePermissions();
  const notify = useNotify();
  const redirect = useRedirect();
  const dataProvider = useDataProvider();

  const handleSubmit = async (values) => {
  try {
    await dataProvider.create("user-guides", {
      data: values,
    });

    notify("User guide created successfully 🎉", {
      type: "success",
    });

    redirect("/user-guides");
  } catch (error) {
    notify(error.message || "Error", { type: "error" });
  }
};

  if (
    !(
      permissions.includes("user-guides.create") ||
      permissions.includes("user-guides.*") ||
      permissions.includes("*")
    )
  ) {
    return null;
  }

  return (
    <Create title="Create User Guide">
      <SimpleForm onSubmit={handleSubmit}>
        <ReferenceInput source="course_id" reference="courses">
          <SelectInput optionText="course_name" validate={required()} />
        </ReferenceInput>

        <TextInput source="title" validate={required()} fullWidth />

        <FileInput source="file" accept="application/pdf">
          <FileField source="src" title="title" />
        </FileInput>

        <BooleanInput source="is_active" defaultValue={true} />
      </SimpleForm>
    </Create>
  );
};

export default UserGuideCreate;